import { FC } from "react";
import { getStaticUrl, getUrlByContext } from "../../../utils";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { FileTextOutlined, PlayCircleOutlined, SearchOutlined } from "@ant-design/icons";

interface NewsMatchLinksProps {
    reportUrl?: string;
    videoUrl?: string;
    textLiveUrl?: string;
    reviewUrl?: string;
}

export const NewsMatchLinks: FC<NewsMatchLinksProps> = ({
    reportUrl,
    videoUrl,
    textLiveUrl,
    reviewUrl,
}) => {
    const config = useConfiguration();

    if (!reportUrl && !videoUrl && !textLiveUrl && !reviewUrl) {
        return null;
    }

    let videoTitle = 'Запись';

    const linkClassNames = "text-slate-950 border border-solid border-slate-300 sm:min-w-[140px] p-2 px-3 text-lg font-semibold flex rounded-full bg-white flex-row justify-center items-center gap-1 max-w-full box-border hover:bg-gray-50 hover:no-underline uppercase active:scale-95 transition-all";
    const labelClassNames = "text-base sm:text-lg"; //"hidden sm:block";
    const iconClassNames = "w-6";
    return (
        <div className="box-border mx-auto py-3">
            <div className="flex flex-row flex-wrap box-border mx-auto text-center items-center justify-center gap-1 sm:gap-2">
                {reportUrl && <a href={getUrlByContext(reportUrl, config.teamName)} className={linkClassNames} rel="noreferrer">
                    <FileTextOutlined />
                    <span className={labelClassNames}>Протокол</span>
                </a>}
                {videoUrl && <a href={videoUrl} className={linkClassNames} rel="noreferrer">
                    <PlayCircleOutlined />
                    <span className={labelClassNames}>{videoTitle}</span>
                </a>}
                {textLiveUrl && <a href={textLiveUrl} className={linkClassNames} rel="noreferrer noopener">
                    <img src={getStaticUrl("/static/images/match/text.png")} className={iconClassNames} alt="Текстовая трансляция" />
                    <span className={labelClassNames}>Текстовая</span>
                </a>}
                {reviewUrl && <a href={reviewUrl} className={linkClassNames} rel="noreferrer noopener">
                    <SearchOutlined />
                    <span className={labelClassNames}>Обзор</span>
                </a>}
            </div>
        </div>
    );
}